/* global $, tfl_validate, grecaptcha */

import Verify_Email from "./libraries/email_verification.js";

Promise.all([
  import(/* webpackChunkName: "validation" */ "./loaders/validation-loader"),
]).then(() => {
  setup();
  document.addEventListener("remount:register", remount);
});

function remount() {
  setupFormValidation();
  setupSubmitValidation();
}

function setup() {
  remount();
}

function setupFormValidation() {
  tfl_validate.push([
    "#registration_form",
    {
      onsubmit: false,
      focusInvalid: true,
      errorElement: "div",
      errorClass: "login__tiptext login__tiptext--warn",
      highlight: function (element, errorClass, validClass) {
        $(element).closest("div.login__field").addClass('login__field--warn').removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).closest("div.login__field").removeClass('login__field--warn').addClass(validClass);
      },
      rules: {
        "input-name-first": {
          required: true,
        },
        "input-name-last": {
          required: true,
        },
        "input-email": {
          required: true,
          email: true,
        },
      },
    }
  ]);
}

function setupSubmitValidation() {
  $(document).on("click", "#registration_submit", function (event) {
    event.preventDefault();
    const form = $("#registration_form");

    // Recaptcha Functionality
    grecaptcha.ready(function () {
      const recaptcha_id = form.find('.recaptcha_widget');
      const recaptcha = recaptcha_id.first();
      const sitekey = recaptcha.data('sitekey');
      grecaptcha.execute(sitekey, { action: 'email_registration' }
      ).then(function (token) {
        document.getElementById('g-recaptcha-response').value = token;
        Verify_Email({ "$form": form, "source": "registration", "emailInputId": "input-email" })
      });
    });
  });
}